// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhf_a bie_bi"};